<template>
    <div class="body">
        <div class="item" @click="onStar">
            <van-icon :name="like" class="icon"/>
            <div class="title">点赞</div>
        </div>

        <div class="item" @click="onCollect">
            <van-icon :name="collect" class="icon"/>
            <div class="title">收藏</div>
        </div>

        <div class="item" @click="onComment">
            <van-icon name="comment-o" class="icon"/>
            <div class="title">评论</div>
        </div>

        <div class="item" @click="onShare">
            <van-icon name="share-o" class="icon"/>
            <div class="title">分享</div>
        </div>

        <!-- 评论发布区域 -->
        <comment-popup ref="commentPopup"/>
        <van-popup
            v-model:show="showShare"
            style="text-align: center;
                    width: 70vw;
                    height: 20vw;
                    line-height: 20vw;
                    border-radius: 10px;
                    overflow: inherit;"
        >
            <share style="z-index: 3000"/>
        </van-popup>

    </div>
</template>

<script>
import {Share} from 'vue3-social-share';
import 'vue3-social-share/lib/index.css'
import { Dialog, Toast } from 'vant'
import { doStarResource, doCollectResource, getItemResource, getResource, rmCollectResource } from '@/api/CommonApi'
import CommentPopup from "@/components/commentPopup";
import { inject, ref, watch } from '@vue/runtime-core';

export default {
    name: 'ActionBar',
    components: {CommentPopup, Share},
    inject:[
        'resourceId', // 当前专辑ID
        'resourceItemId', // 当前专辑下资源的ID
        'enableComment', // 是否启用评论
    ],
    setup() {
        const showShare = ref(false)
        const isLike = ref(false)
        const isCollect = ref(false)
        const resourceId = inject('resourceId')
        const itemId = inject('resourceItemId')

        watch([resourceId, itemId], ([resourceId, itemId]) => {
            getItemResource(resourceId, itemId).then(res => {
                const result = res.result
                isLike.value = result.isUserSupport || false
            })
            getResource(resourceId).then(res => {
                const result = res.result
                isCollect.value = result.isUserCollect || false
            })
        })

        return {
            showShare,
            isLike,
            isCollect
        }
    },
    computed: {
        like() {
            return this.isLike ? 'good-job' : 'good-job-o'
        },
        collect() {
            return this.isCollect ? 'star' : 'star-o'
        }
    },
    methods: {
        onStar() {
            const token = localStorage.getItem('token')
            if(token === null || token === '') {
                this.go2Login()
                return
            }

            if(this.isLike) {
                Toast.success('已点赞该资源！')
                return
            }

            const resourceId = this.resourceId
            const itemId = this.resourceItemId
            doStarResource(resourceId, itemId).then(res => {
                console.log(res)
                if(res.code == 200 && res.success) {
                    Toast.success('点赞成功！')
                    this.isLike = true
                } else {
                    Toast.fail(res.message)
                }
            }).catch(err => Toast.fail(err.message))
        },
        onCollect() {
            const token = localStorage.getItem('token')
            if(token === null || token === '') {
                this.go2Login()
                return
            }

            const resourceId = this.resourceId
            if(this.isCollect) {
                rmCollectResource(resourceId).then(res => {
                    if(res.code == 200 && res.success) {
                        Toast.success('取消收藏成功！')
                        this.isCollect = false
                    } else {
                        Toast.fail(res.message)
                    }
                }).catch(err => Toast.fail(err.message))
                return
            }

            doCollectResource(resourceId).then(res => {
                if(res.code == 200 && res.success) {
                    Toast.success('收藏成功！')
                    this.isCollect = true
                } else {
                    Toast.fail(res.message)
                }
            }).catch(err => Toast.fail(err.message))
        },
        onComment() {
            if(!this.enableComment){
                Toast.fail('当前资源评论区暂未开放')
                return
            }
            // 显示评论区
            this.$refs.commentPopup.showPopup()
        },
        onShare() {
            this.showShare = true
        },
        go2Login() {
            Dialog.confirm({
                title: '请登录后继续',
                message:
                    '是否现在前往登录',
            }).then(() => {
                this.$router.push('/login')
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.body {
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
}

.item {
    width: 25%;
    text-align: center;
}

.icon {
    font-size: 20px;
}

.title {
    font-size: 14px;
    color: #4E4E4E;
}

.share-bar {
    text-align: center;
    width: 70vw;
    height: 20vw;
    line-height: 20vw;
    border-radius: 10px;
}
</style>
